import { render, staticRenderFns } from "./NotasNivel1.vue?vue&type=template&id=9e84f168"
import script from "./NotasNivel1.vue?vue&type=script&lang=js"
export * from "./NotasNivel1.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel1.vue?vue&type=style&index=0&id=9e84f168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports